import React, { useEffect, useContext, useState } from "react";
import PerfectScrollbar from "react-perfect-scrollbar";
import { AppSettings } from "./../../config/app-settings.js";
import { Link } from "react-router-dom";

function EmailContract() {
  const context = useContext(AppSettings);
  const [mailData, setMailData] = useState();
  const [selectedMailData, setSelectedMailData] = useState(null);

  useEffect(() => {
    context.setAppContentFullHeight(true);
    context.setAppContentClass("p-3");

    fetch("/assets/data/email/inbox.json")
      .then((res) => res.json())
      .then((result) => {
        setMailData(result);
      });

    return function cleanUp() {
      context.setAppContentFullHeight(false);
      context.setAppContentClass("");
    };

    // eslint-disable-next-line
  }, []);

  return (
    <div className="mailbox">
      <div className="mailbox-toolbar">
        <div className="mailbox-toolbar-item">
          <span className="mailbox-toolbar-text">Deals</span>
        </div>
        <div className="mailbox-toolbar-item">
          <Link to="/deals/detail" className="mailbox-toolbar-link">
            Clientes
          </Link>
        </div>
        <div className="mailbox-toolbar-item">
          <Link to="/deals/create" className="mailbox-toolbar-link">
            Entrevista
          </Link>
        </div>
        <div className="mailbox-toolbar-item">
          <Link to="/deals/analytics" className="mailbox-toolbar-link">
            Analítica
          </Link>
        </div>
        <div className="mailbox-toolbar-item">
          <Link to="/deals/tools" className="mailbox-toolbar-link">
            Tools
          </Link>
        </div>
        <div className="mailbox-toolbar-item">
          <Link to="/deals/contract" className="mailbox-toolbar-link active">
            Contrato
          </Link>
        </div>
      </div>
      <div className="mailbox-body">
        <div className="mailbox-sidebar d-lg-block">
          <PerfectScrollbar className="h-100">
            <div className="mailbox-list">
              {mailData && mailData.length > 0 ? (
                mailData.map((registro, index) => (
                  <div
                    key={index}
                    className="mailbox-list-item"
                    onClick={() => setSelectedMailData(registro)} // Selección dinámica
                  >
                    <div className="mailbox-message">
                      <Link to="#" className="mailbox-list-item-link">
                        <div className="mailbox-sender">
                          <span className="mailbox-sender-name">
                            {registro.nombre} {registro.apellido}
                          </span>
                          <span className="mailbox-time">
                            {registro.created_at}
                          </span>
                        </div>
                        <div className="mailbox-title">
                          {registro.marca} {registro.modelo} - {registro.anio}
                        </div>
                      </Link>
                    </div>
                  </div>
                ))
              ) : (
                <div
                  className="mailbox-list-item"
                  style={{ minWidth: "360px" }}
                >
                  No hay registros
                </div>
              )}
            </div>
          </PerfectScrollbar>
        </div>

        <div className="mailbox-content">
          <PerfectScrollbar className="h-100">
            {selectedMailData ? (
              <div className="mailbox-detail">
                <div className="mailbox-detail-header">
                  <div className="d-flex align-items-center">
                    <div className="flex-fill ms-3">
                      <div className="fw-semibold black-text">
                        {selectedMailData.nombre} {selectedMailData.apellido}
                      </div>
                      <div className="correo-text">{selectedMailData.correo}</div>
                    </div>
                  </div>
                </div>
                <div className="mailbox-detail-content">
                  <h5>Detalles del Vehículo</h5>
                  <ul>
                    <li>Marca: {selectedMailData.marca}</li>
                    <li>Modelo: {selectedMailData.modelo}</li>
                    <li>Año: {selectedMailData.anio}</li>
                    <li>Versión: {selectedMailData.version}</li>
                    <li>Condición: {selectedMailData.condicion}</li>
                    <li>Precio Total: {selectedMailData.precio_total}</li>
                    <li>
                      Financiamiento Meses:{" "}
                      {selectedMailData.financiamiento_meses}
                    </li>
                    <li>
                      Enganche Porcentaje:{" "}
                      {selectedMailData.enganche_porcentaje}
                    </li>
                    <li>
                      Mensualidad Estimada:{" "}
                      {selectedMailData.mensualidad_estimada}
                    </li>
                  </ul>
                  <h5>Información del Cliente</h5>
                  <ul>
                    <li>Teléfono: {selectedMailData.telefono}</li>
                    <li>Código Postal: {selectedMailData.codigo_postal}</li>
                    <li>Comentario: {selectedMailData.comentario}</li>
                    <li>
                      Motivo de Rechazo: {selectedMailData.motivo_rechazo}
                    </li>
                    <li>Fecha de Registro: {selectedMailData.created_at}</li>
                  </ul>
                </div>
              </div>
            ) : (
              <div
                className="mailbox-detail-placeholder"
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  height: "100%",
                  textAlign: "center",
                }}
              >
                Seleccione un cliente para ver los detalles
              </div>
            )}
          </PerfectScrollbar>
        </div>
      </div>
    </div>
  );
}

export default EmailContract;
